import { Box } from '@wix/design-system';
import {
  ProductHat,
  useProductHat,
  useRevShare,
} from '@wix/package-picker-shared-studio';
import { ProductCardList } from '@wix/premium-purchase-platform/@components';
import classNames from 'classnames';
import React from 'react';
import { StudioPackagePickerModule } from '../../../modules/studio-package-picker.module';
import { CardContent } from './CardContent';
import s from './ProductCard.scss';

const HAT_HEIGHT = '28px';

interface BaseProductCardProps {
  productId: string;
}

export const BaseProductCard = ({ productId }: BaseProductCardProps) => {
  useRevShare({ productId });
  const { data: product } =
    StudioPackagePickerModule.SDK.studioOfferingApiClient.hooks.useFetchProduct(
      { productId },
    );
  const { hasHat } = useProductHat({ productId });
  const isRecommended = Boolean(product?.isRecommended);

  return (
    <Box direction="vertical" flex="1" gap="8px">
      <Box height={HAT_HEIGHT}>
        {hasHat && (
          <ProductHat
            productId={productId}
            height={HAT_HEIGHT}
            borderRadius="6px"
          />
        )}
      </Box>
      <ProductCardList.Default.Card.Root
        width="100%"
        padding="20px"
        borderRadius="12px"
        className={classNames(s.card, { [s.recommendedCard]: isRecommended })}
      >
        <CardContent productId={productId} isRecommended={isRecommended} />
      </ProductCardList.Default.Card.Root>
    </Box>
  );
};
